export default __webpack_public_path__ + "static/media/doodle.975e7a50.jpg";